import { NamedEntityDto } from "approot/global/models/common.model";
import { AppContext } from "approot/global/services/context";

export class MobileRepository {
	/*@ngInject*/
	constructor(private $http: ng.IHttpService) {

	}

	requestPinCode(): ng.IPromise<GetUserCodeResult> {
		return this.$http.get<GetUserCodeResult>("/webapi/mysettings/mobile/pincode")
			.then((response) => response.data);
	}

	requestConsent(): ng.IPromise<boolean> {
		return this.$http.get<boolean>("/webapi/mysettings/mobile/consent")
			.then((response) => response.data);
	}

	setLink(): ng.IPromise<GetUserCodeResult> {
		return this.$http.post<GetUserCodeResult>("/webapi/mysettings/mobile/set-link", null)
			.then((response) => response.data);
	}

	getProductName(): ng.IPromise<string> {
		return this.$http.get<string>("/webapi/sysinfo/product-name")
			.then((response) => response.data);
	}

	getUserNickname(): ng.IPromise<NamedEntityDto> {
		return this.$http.get<NamedEntityDto>('/webapi/users/get-mobile')
			.then((response) => response.data);
	}

	logout(): ng.IHttpPromise<void> {
		return this.$http.post<void>("/webapi/auth/logout", null);
	}

	getContext(): ng.IPromise<AppContext> {
		return this.$http.get<AppContext>("/webapi/context")
			.then((response) => response.data);
	}
}

export interface GetUserCodeResult {
	subjectId: string;
	userCode: string;
}